export default __webpack_public_path__ + "static/media/image-ph-health-statistics-m@3x.3649c018.webp";